import { useAuth } from '@/hooks/use-auth'

const localeVariantMap = {
  'pt-BR': 'brasil',
  'es-CL': 'chile',
} as const
type Variant = (typeof localeVariantMap)[keyof typeof localeVariantMap]
const DEFAULT_LOCALE: Variant = 'brasil'

function useLocale(): Variant {
  const { user } = useAuth()
  const locale = user?.localidade ?? 'pt-BR'
  return localeVariantMap[locale] ?? DEFAULT_LOCALE
}

type LocaleConfig = {
  exibirItens: boolean
}
const localeConfigMap: Record<Variant, LocaleConfig> = {
  brasil: {
    exibirItens: true,
  },
  chile: {
    exibirItens: false,
  },
}

export function useLocaleConfig(): LocaleConfig {
  const locale = useLocale()
  return localeConfigMap[locale]
}
